import React, { memo, useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3, FiEye } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import {
  fetchData,
  fetchFormData,
  getValueLabel,
  formatDateOnly,
} from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import SelectDropdown from "../shared/SelectDropdown";
import ConfirmModal from "../shared/ConfirmModal";
import Swal from "sweetalert2";
import { leadPriorityData } from "../../utils/options";

const UnassignedTable = ({ filteredData = null, permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [Data, setData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [id, setId] = useState();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("moduleId", M_id);

      const result = await fetchFormData(
        "inquiries/unassingned-list",
        formData,
        "POST"
      );

      if (result && result.data) {
        setId(result.data[2].TransitionID);
        setData(result.data || []);
      } else {
        setData([]);
        Swal.fire("No Data", result?.message || "No tasks found", "info");
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
      Swal.fire("Error", "Failed to load tasks", "error");
    } finally {
      setLoading(false);
      Swal.close();
    }
  };

  const columns = [
    {
      id: "select",
      header: () => (
        <input
          type="checkbox"
          onChange={() => {
            if (selectedRowIds.length === Data.length) {
              setSelectedRowIds([]);
            } else {
              setSelectedRowIds(Data.map((row) => row.id));
            }
          }}
          checked={selectedRowIds.length === Data.length}
          ref={(input) => {
            if (input) {
              input.indeterminate =
                selectedRowIds.length > 0 &&
                selectedRowIds.length < Data.length;
            }
          }}
        />
      ),
      cell: ({ row }) => {
        const id = row.original.id;
        return (
          <input
            type="checkbox"
            checked={selectedRowIds.includes(id)}
            onChange={() => {
              setSelectedRowIds((prev) =>
                prev.includes(id)
                  ? prev.filter((item) => item !== id)
                  : [...prev, id]
              );
            }}
          />
        );
      },
      meta: {
        headerClassName: "width-10",
        exportable: false,
      },
    },
    {
      accessorKey: "Inquiries_Id",
      header: "Inquiry id",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "customer_name",
      header: "Customer Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "phone_number",
      header: "Phone Number",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "alternate_number",
      header: "Alternate Number",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "payouts",
      header: "Payouts",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "loan_amount",
      header: "Inquiry Amount",
      defaultIsVisible: true,
      cell: (info) =>
        Number(info.getValue()).toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
        }),
    },
    {
      accessorKey: "lead_source_name",
      header: "Inquiry Source",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "source",
      header: "Source",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "alternate_number0",
      header: "Alternate Number",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    const shouldFetch =
      !Array.isArray(filteredData) || filteredData.length === 0;

    if (shouldFetch) {
      fetchData();
    } else {
      setData(filteredData);
    }
  }, [filteredData]);

  return (
    <>
      <Table data={Data} columns={columns} />
      <div className="mt-3 text-end d-flex justify-content-center mb-3 ">
        <Link
          to={`/assigned-inquiry?ID=${id}`}
          state={{
            selectedLeads: Data.filter((d) =>
              selectedRowIds.includes(d.id)
            ).map((item) => ({
              id: item.id,
              numberOfLead: 1,
            })),
            insertedCount: selectedRowIds.length,
          }}
          className="btn btn-primary"
        >
          Submit
        </Link>
      </div>
    </>
  );
};
export default UnassignedTable;
